import React from 'react'
import { Button, Divider, message, Popconfirm } from "antd";
import { post } from '../../axios';
import { API_houseType_findPage, API_houseType_delete } from '../../axios/config';
import TableDOM from '../../components/Table';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import HouseTypeDetail from "./detail";
import { syncStatusIsMap} from '../../axios/dictionaries';
import AuthButton from "../../components/AuthButton/AuthButton";
import JrApiLog from "../Other/JrApiLog"
import { isPlatform} from '../../utils';

class HouseTypeList extends React.Component{
  state = {
    dataList: [],
    dataListLoading: false,
    dataListTotal: 0,
    queryData: {
      syncStatus:'',
      keyword:'',
      shortName:'',
      buildingName:'',
      projectName: '',
      pageSize: 10
    },
    current: 1, //当前页
    pagination: { current:1, pageSize: 10 }
  }
  componentDidMount() {
    this.postHouseTypeList()
  }
  postHouseTypeList() {
    const params = {...this.state.queryData, ...this.state.pagination}
    this.setState({  dataListLoading: true })
    post({ url: API_houseType_findPage, data: params }).then(res => {
        console.log(res)
        this.setState({
        dataList : res.records,
        dataListTotal : res.total, dataListLoading:false,
        pagination:{current : res.current}
      })
    }).catch(err => {
        message.error(err.message || '获取列表失败');
        this.setState({ dataListLoading: false });
    })
  }
  postHouseTypeDelete(id) {
      return post({ url: API_houseType_delete  +'?id=' + id }).then(() => {
        message.success('删除成功')
      }).catch(e => {
        message.error(e.message)
      })
  }

  handleJrApiLogInfo(tableName,id) {
    //console.log(this);
    this.jrApiLogRef.open(tableName,id);
  }

  handleSearch(e) {
    this.setState(state => {
      state.queryData.keyword = e.keyword
      state.queryData.syncStatus = e.syncStatus
      state.queryData.shortName = e.shortName
      state.queryData.buildingName = e.buildingName
      state.queryData.projectName = e.projectName
      state.pagination.current = 1
      return state
    },() => {
      this.postHouseTypeList()
    })
  }

  handlePageChange(e){
    this.setState(state => {
      state.pagination.current = e.current
      return state
    },() => {
      this.postHouseTypeList()
    })

  }

  handleEdit(id) {
    this.HouseTypeDetailRef.open(id).then(res => {
      this.postHouseTypeList()
    })
  } 
  handleDelete(id) {
    this.postHouseTypeDelete(id).then(() =>{
      this.postHouseTypeList()
    })
  }
  render(){
    const columns = [
      { title: '小区/楼栋', dataIndex: 'buildingName', width:200 ,fixed: 'left'},
      { title: '所在门店', dataIndex: 'ccbProjectName', width:200,fixed: 'left' },
      { title: '户型名称', dataIndex: 'roomTypeName', fixed: 'left' },
      { title: '租金范围', dataIndex: 'maxRent',  render: (_,records) => {
        return records.minRent + ' ~ ' + records.maxRent
      } },
      { title: '计租面积', dataIndex: 'maxArea',  render:(_,records) => {
        return records.minArea + ' ~ ' + records.maxArea
      } },
      { title: '阳台', dataIndex: 'balcony', render: (text) => {
        return text + '个'
      } },
      { title: '卫生间', dataIndex: 'bathroom', render: (text) => {
        return text + '个'
      }  },
      // {
      //   title: '同步状态 | 建融Id',
      //   dataIndex: 'name33',
      //   render(text, record, index) {
      //     return <span>
      //               <div>{record.jrRoomTypeId ? "同步成功" : "未同步"}</div>
      //       {
      //         record.jrRoomTypeId
      //             ? <React.Fragment>
      //               <div>{record.jrRoomTypeId ? record.jrRoomTypeId : ''}</div>
      //             </React.Fragment>
      //             : null
      //       }
      //           </span>
      //   }
      // },
      {
        title: '商户简称',
        dataIndex: 'shortName'
      },
      {
        title: '操作', dataIndex: 'action', width: 150, fixed: 'right',
        render:(_,records) => [
        <AuthButton authkey="c-4-2">
        <a onClick={() => this.handleEdit(records.id)}>编辑</a>
            <Divider type="vertical" />
        </AuthButton>
            ,
          // <AuthButton authkey="c-4-5">
          //   <a onClick={() => this.handleJrApiLogInfo('roomType',records.id)}>建融日志</a>
          //     <Divider type="vertical" />
          // </AuthButton>
          <AuthButton authkey="c-4-4">

             <Popconfirm title="确认删除吗" onConfirm={this.handleDelete.bind(this,records.id)}>
          <a>删除</a>
           </Popconfirm>
          </AuthButton>
      ] }
    ]

    const searchData = () => {
     let _data= [{
        tagName: 'Select',
        formConfig: { name: 'syncStatus' },
        attribute: { placeholder: '请选择同步状态', style: { width: '150px' } },
        optionData: [{ title: '全部', value: '' }].concat(syncStatusIsMap), //.concat(dicHouseStatus)
        notResult: '',
      },
      {
        tagName: 'Input',
        formConfig: { name: 'shortName' },
        attribute: { placeholder: '输入商户', style: { width: '150px' } },
      },
      {
        tagName: 'Input',
        formConfig: { name: 'buildingName' },
        attribute: { placeholder: '输入小区楼栋', style: { width: '150px' } },
      },
      {
        tagName: 'Input',
        formConfig: { name: 'projectName' },
        attribute: { placeholder: '输入门店', style: { width: '150px' } },
      },
      {
          tagName: 'InputTip',
          formConfig: { name: 'keyword' },
          attribute: { placeholder: '输入关键字', style: { width: '150px' } },
          title: `在户型名称、建融户型id内模糊查询`
      },
    ];

      _data = _data.filter(e => {
         if(isPlatform()){
             return true;
         }
         if (e.formConfig.name === 'shortName') {
             return false;
         }
         return true;
     });

       return _data;
    };

    return (
      <PageWrap loading={false}>
        <div className="search-wrapper ">
          <div className="search-btn-list" >
            <AuthButton authkey="c-4-3">
              <Button icon="plus" type="primary" onClick={() => this.handleEdit()}>新增</Button>
            </AuthButton>
        </div>
        <SuperForm
          onRef={ref => this.superFormRef = ref}
          data={searchData()}
          sumbit={this.handleSearch.bind(this)}
          addParams={'current'}
        />
        </div>

        <TableDOM 
          loading={this.state.dataListLoading}
          total={this.state.dataListTotal}
          current={this.state.pagination.current}
          onChange={this.handlePageChange.bind(this)}
          columns={columns}
          data={this.state.dataList}
          pagination={this.state.pagination}
          scroll={{x: 1500}}
        />

        <JrApiLog ref={ref=>{
          this.jrApiLogRef=ref
        }} 
        />


        <HouseTypeDetail wrappedComponentRef={ ref=> this.HouseTypeDetailRef = ref } />
      </PageWrap>
    )
  }
}

export default HouseTypeList


// WEBPACK FOOTER //
// ./src/page/HouseType/index.jsx